import { FocusScope } from "@react-aria/focus"
import { useHover } from "@react-aria/interactions"
import PropTypes from "prop-types"
import { useContext } from "react"
import { connect } from "react-redux"

import { deactivateSubmenu } from "app-store-v2/app/actions"
import { HeaderMenuContext } from "areas/header/portal"

import MenuItem from "./menu-item"

const InternalDesktopMenu = ({ leftMenu }) => {
  const { menu } = useContext(HeaderMenuContext)
  const { hoverProps } = useHover({
    onHoverEnd: () => leftMenu(),
  })

  const menuItems = menu && menu.categories
  // const saleItems =
  //   saleMenu && saleMenu.map((link) => ({ ...link, type: "link" }))
  // const items = [...menuItems, ...saleItems]
  const items = menuItems

  return (
    <nav
      aria-label="Main Navigation"
      className="mx-auto flex w-full justify-center px-24"
      id="nav-menu"
      {...hoverProps}
    >
      <FocusScope>
        <ul
          aria-orientation="horizontal"
          className="large:gap-32 relative flex list-none flex-nowrap items-center justify-start gap-24"
          role="menubar"
        >
          {items.map((item, index) => (
            <MenuItem index={index} item={item} key={`${item.name}-${index}`} />
          ))}
        </ul>
      </FocusScope>
    </nav>
  )
}

InternalDesktopMenu.propTypes = {
  leftMenu: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    saleMenu: state.sale.menu.desktop,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    leftMenu: () => dispatch(deactivateSubmenu()),
  }
}

const DesktopMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDesktopMenu)

export default DesktopMenu
